import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { TrendingUp, TrendingDown, Eye } from 'lucide-react';

/**
 * StatCard Component - Reusable stat display card for dashboards
 * 
 * @param {string} title - Card title
 * @param {string|number} value - Main value to display
 * @param {number} change - Percentage change (optional)
 * @param {React.Component} icon - Lucide icon component
 * @param {string} trend - "up" or "down" for trend indicator
 * @param {string} color - Tailwind color name (default: "amber")
 * @param {string} clickType - Type identifier for click handling (optional)
 * @param {function} onClick - Click handler function (optional)
 */
export const StatCard = ({ 
  title, 
  value, 
  change, 
  icon: Icon, 
  trend, 
  color = "amber", 
  clickType,
  onClick 
}) => (
  <Card 
    className={`bg-stone-900 border-stone-800 ${clickType || onClick ? 'cursor-pointer hover:bg-stone-800/50 hover:border-stone-700 transition-all' : ''}`}
    onClick={() => (clickType || onClick) && onClick?.(clickType)}
    data-testid={`stat-card-${title?.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-stone-400 text-sm flex items-center gap-2">
            {title}
            {(clickType || onClick) && <Eye className="w-3 h-3 opacity-50" />}
          </p>
          <p className="text-2xl font-bold text-white mt-1">{value}</p>
          {change !== undefined && (
            <div className={`flex items-center gap-1 mt-1 text-sm ${trend === "up" ? "text-green-400" : "text-red-400"}`}>
              {trend === "up" ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              <span>{change}%</span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 rounded-xl bg-${color}-500/20 flex items-center justify-center`}>
          {Icon && <Icon className={`w-6 h-6 text-${color}-400`} />}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default StatCard;
